export enum ECountryCode {
  ID = "Indonesia",
  PH = "Philippines",
  TH = "Thailand",
  VN = "Vietnam",
  SG = "Singapore",
  US = "United States",
  DEFAULT = "",
}

export enum EUserTypes {
  INDIVIDUAL = "individual",
  COMPANY = "company",
}

export enum EDomicileTypes {
  LOCAL = "local",
  FOREIGN = "foreign",
}

export enum EUserRoles {
  DIRECTOR = "Director",
  BUSINESS_OWNER = "Business Owner",
}
